module.exports = __webpack_public_path__ + "static/media/bda.c016bed8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/journey/bda.png
// module id = 314
// module chunks = 0